import HeaderTabsContainer, { TabButton } from '@/header/HeaderTabsContainer';
import {
    CASINO_GAME_HRY_CATEGORY,
    CASINO_GAME_KASINO_CATEGORY,
    CASINO_HRY_LOBBY,
    CASINO_LOBBY
} from '@/routing/routes';
import { CASINO_TAB } from 'nike-ui/src/components/casino/constants';
import React from 'react';
import useHeaderTabsScroll from '@/_hooks/useHeaderTabsScroll';
import i18n from '@i18n';
import moment from 'moment';

function CasinoTabs({ active }) {
    const scrollElementRef = useHeaderTabsScroll();
    const actualDate = moment().format('YYYY-MM-DD');
    const endDate = moment('2022-01-31').format('YYYY-MM-DD');
    const showDate = actualDate < endDate;

    return (
        <HeaderTabsContainer>
            <TabButton
                route={CASINO_LOBBY}
                i18nCode="casino.uvod"
                activeRoute={active}
                trackData={{ category: 'Svet hier', action: 'Uvod tab' }}
                scrollElementRef={scrollElementRef}
            />
            <TabButton
                route={CASINO_GAME_KASINO_CATEGORY}
                i18nCode={'casino.games.kasino'}
                activeRoute={active}
                casinoTab={CASINO_TAB.KASINO}
                trackData={{ category: 'Svet hier', action: 'Redtiger tab' }}
                scrollElementRef={scrollElementRef}
            />
            <TabButton
                route={CASINO_HRY_LOBBY}
                activeCheck={[CASINO_GAME_HRY_CATEGORY]}
                i18nCode="casino.games.hry"
                activeRoute={active}
                casinoTab={CASINO_TAB.HRY}
                trackData={{ category: 'Svet hier', action: 'Iforium a EGaming tab' }}
                scrollElementRef={scrollElementRef}
                badgeMsg={showDate ? i18n('bookmarks.menu.button.new') : null}
            />
        </HeaderTabsContainer>
    );
}

export default CasinoTabs;
